import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonFunction } from '../helpers/commonFunction';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {



  constructor(private http: HttpClient, private commonFunction: CommonFunction) { }

  sendMessage(message): Promise<any> {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));

    var decrEmailId = this.commonFunction.decrypt(user.EmailId);
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI Detail All';

    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }
    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,

      EmailId: decrEmailId,
      companyDetails: companyDetails,
      title: user.Title
    }

    var PSSDetail = localStorage.getItem('companyDetails');

    var UserDetail = JSON.stringify(loginUser);
    let headers = {};
    let head = (key, header) => { headers[key] = header };
    head('Content-Type', 'application/json');
    head('Access-Control-Allow-Origin', '*');
    head('PSSDetail', PSSDetail);
    head('UserDetail', UserDetail);
    head('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

    var token = localStorage.getItem('token')
    head("x-access-token", token)

    const payload = {
      text: message
    };

    return this.http.post(environment.chatbotURL + '/robocs/extract', payload, { headers })
      .toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
  }

 


  getBalanceSheet(symbol: string): Observable<any> {
    return this.http.get<any>(environment.chatbotURL + '/balance-sheet', {
      params: { symbol }
    });
  }

  getKeyRatios(symbol: string): Observable<any> {
    return this.http.get<any>(environment.chatbotURL + '/financial-ratios', {
      params: { symbol }
    });
  }

  getIncomeStatement(symbol: string): Observable<any> {
    return this.http.get<any>(environment.chatbotURL + '/income-statement', {
      params: { symbol }
    });
  }

  getBalanceSheetStandalone(symbol: string): Observable<any> {
    const headers = new HttpHeaders({
      symbol: symbol
    });
    return this.http.get<any>(environment.clientUrl + 'financial/balance-sheet/standalone', {
      headers
    });
  }

  getBalanceSheetConsolidated(symbol: string): Observable<any> {
    const headers = new HttpHeaders({
      symbol: symbol
    });
    return this.http.get<any>(environment.clientUrl + 'financial/balance-sheet/consolidated', {    headers
    });
  }
  getPLQuarterlyStandalone(symbol: string): Observable<any> {
    const headers = new HttpHeaders({
      symbol: symbol
    });
    return this.http.get<any>(environment.clientUrl + 'financial/pl/standalone/quarterly', {
      headers
    });
  }
  getPLQuarterlyConsolidated(symbol: string): Observable<any> {
    const headers = new HttpHeaders({
      symbol: symbol
    });
    return this.http.get<any>(environment.clientUrl + 'financial/pl/consolidated/quarterly', {
      headers
    });
  }

  getPLAnnualStandalone(symbol: string): Observable<any> {
    const headers = new HttpHeaders({
      symbol: symbol
    });
    return this.http.get<any>(environment.clientUrl + 'financial/pl/standalone/annual', {
      headers
    });
  }
  getPLAnnualConsolidated(symbol: string): Observable<any> {
    const headers = new HttpHeaders({
      symbol: symbol
    });
    return this.http.get<any>(environment.clientUrl + 'financial/pl/consolidated/annual', {
      headers
    });
  }
  //Given by harshal for financial extract
  // getFinancialExtractQuarter(): Observable<any> {
  //   return this.http.get<any>(environment.financialExtractURL + '/extract?type=quarter', {
  //     // params: { symbol }
  //   });
  // }
  // getFinancialExtractAnnual(): Observable<any> {
  //   return this.http.get<any>(environment.financialExtractURL + '/extract?type=annual', {
  //     // params: { symbol }
  //   });
  // }
}
 